import React from 'react';

import { useState, useEffect } from 'react';
import Exclamation from '../../../../assets/icons/Exclamation';
import {
  Container,
  Header,
  Footer,
  Label,
  Reminder,
  ReText,
  Empty,
  DivIcon,
} from './styles';
import Input from '../../../../components/general/Input';
import Button from '../../../../components/general/Button';
import Close from '../../../../assets/icons/Close';
import Modal from '../../../../components/general/Modal';
import { handleRenameFlow } from '../../../../state/flows/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toastAlert } from '../../../../components/Toastify/index';
import { getAllFlowsTitleNames } from '../../../../state/flows/selectors';
import { usePromiseTracker, trackPromise } from 'react-promise-tracker';
import ReactLoading from 'react-loading';

const RenameVersion = ({
  title,
  version,
  isOpen,
  onClose,
  selector = '#root',
  className = 'nodrag',
  state,
}) => {
  const [projectTitle, setProjectTitle] = useState('');
  const dispatch = useDispatch();

  const flow = useSelector((state) => state.flows.pane.flow);
  const allflowsTitles = useSelector((state) => getAllFlowsTitleNames(state));
  const { promiseInProgress } = usePromiseTracker({ area: 'rename-flow' });
  useEffect(() => {
    setProjectTitle(title);
  }, [title]);

  const current = useSelector((state) => state.flows.pane.flow.current);

  function VersionException(errorMsg) {
    toastAlert({ msg: `${errorMsg}`, isError: true });
    this.message = `Error Exception: ${errorMsg}`;
  }

  const handleTitleValidation = () => {
    try {
      const findNameVersion = allflowsTitles.find(
        (item) => item.title === projectTitle
      );

      if (findNameVersion) {
        throw new VersionException(
          `ERRO: Todas as versões devem ter nomes distintos!`
        );
      } else {
        handleRename();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleRename = () => {

    trackPromise(
      dispatch(
        handleRenameFlow({
          title: projectTitle,
          flowId: flow.current._id,
          parentId: flow.main._id,
        })
      )
        .then((res) => {
          const title = res.payload?.flow.title;
          toastAlert({
            msg: `Fluxo  '${title}'  RENOMEADO com Sucesso!`,
          });
          onClose();
        })
        .catch((err) => {
          toastAlert({
            msg: `ERRO ao renomear o fluxo '${title}': ${err} `,
            isError: true,
          });
          console.error(err);
        })

      , 'rename-flow')

  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Header>
          <Label>
            {current.type === 'main'
              ? 'Renomear Projeto'
              : 'Renomear versão atual'}
          </Label>
          <Reminder>
            <Exclamation style={{ height: '1.3125rem', width: '1.3125rem' }} />
            <ReText>
              {current.type === 'main'
                ? `Lembrete: Você está renomeando o Projeto:  '${current.title}'`
                : `Lembrete: Você está renomeando a versão:  '${current.title}'`}
            </ReText>
          </Reminder>
          <Empty />
        </Header>

        {!promiseInProgress ? (
          <>
            <Input
              style={{ width: '23.75rem', paddingLeft: '1.875rem', }}
              value={projectTitle}
              setValue={(e) => {
                setProjectTitle(e);
              }}
              label={
                current.type === 'main' ? 'Nome do Projeto' : 'Nome da Versão'
              }
              placeholder="Ex. Review 2.0"
              type="text"
            />
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onClose}
              />
              <Button
                disabled={projectTitle?.length === 0}
                content="Salvar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={state === 'edition' ? handleTitleValidation : undefined}
              />
            </Footer>
          </>
        ) : (
          <div
            style={{
              margin: '0 auto',
              padding: '2rem',

            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>
        )}

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default RenameVersion;
